<template>
  <div class="about">
    <!-- 使用公共导航栏组件 -->
    <common-header
      :is-scrolled="isScrolled"
      :current-section="currentSection"
      @search="handleSearch"
      @lang-change="switchLang"
      @section-change="handleSectionChange"
      @scroll-to-section="scrollToSection"
    />

    <!-- 页面banner -->
    <div class="page-banner">
      <div class="banner-content">
        <h1>{{ $t('about.title') }}</h1>
        <p v-if="$i18n.locale === 'zh'">About Cosys</p>
      </div>
    </div>

    <!-- 子目录导航条 -->
    <div class="about-subnav">
      <div class="subnav-inner">
        <ul>
          <li :class="{active: currentSection === 'profile'}">
            <a href="#" @click.prevent="scrollToSection('profile')">{{ $t('about.profile.title') }}</a>
          </li>
          <li :class="{active: currentSection === 'culture'}">
            <a href="#" @click.prevent="scrollToSection('culture')">{{ $t('about.culture.title') }}</a>
          </li>
          <li :class="{active: currentSection === 'history'}">
            <a href="#" @click.prevent="scrollToSection('history')">{{ $t('about.history.title') }}</a>
          </li>
          <li :class="{active: currentSection === 'honors'}">
            <a href="#" @click.prevent="scrollToSection('honors')">{{ $t('about.honors.title') }}</a>
          </li>
          <li :class="{active: currentSection === 'partners'}">
            <a
              href="#"
              @click.prevent="scrollToSection('partners')"
            >{{ $t('about.partners.title') }}</a>
          </li>
        </ul>
      </div>
    </div>

    <!-- 内容区域 -->
    <div class="content-container" style="padding-bottom: 0; max-width: none;padding: 0;">
      <!-- 公司简介部分 -->
      <section id="profile" class="content-section">
        <div class="section-content" style="padding:0 100px">
          <h2 style=" padding-top:40px;">{{ $t('about.profile.title') }}</h2>
          <div class="profile-content">
            <div class="profile-left">
              <div class="profile-text">
                <p>{{ $t('about.profile.p1') }}</p>
                <p>{{ $t('about.profile.p2') }}</p>
                <p>{{ $t('about.profile.p3') }}</p>
                <p>{{ $t('about.profile.p4') }}</p>
              </div>
            </div>
            <div class="profile-right">
              <img src="@/assets/guan/gsjjbanner.jpg" :alt="$t('about.profile.title')" />
            </div>
          </div>
          <!-- 核心数据区 -->
          <div class="core-stats-bg">
            <div class="core-stats-inner">
              <div class="core-slogan">{{ $t('about.core.slogan') }}</div>
              <div class="core-stats-list">
                <div class="core-stat-item" v-for="(stat, idx) in coreStats" :key="idx">
                  <div class="core-stat-number">
                    {{ stat.display }}
                    <span class="core-unit">{{ $t(`about.core.stats[${idx}].unit`) }}</span>
                  </div>
                  <div class="core-stat-label">{{ $t(`about.core.stats[${idx}].label`) }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>

    <!-- 企业文化部分 -->
    <section id="culture" class="culture-section-full">
      <div class="culture-content">
        <!-- <h2 class="culture-content-title">{{ $t('about.culture.title') }}</h2> -->
        <div class="wenhuabiaoti">{{ $t('about.culture.title') }}</div>
        <div class="culture-grid">
          <!-- 价值观部分 -->
          <div class="culture-item">
            <h3 class="subsection-title">{{ $t('about.culture.values.title') }}</h3>
            <ul class="value-list" :class="{ 'value-list-zh': $i18n.locale === 'zh' }">
              <li
                v-for="(value, index) in $t('about.culture.values.items')"
                :key="index"
              >{{ value }}</li>
            </ul>
          </div>
          <div class="culture-divider"></div>
          <!-- 使命部分 -->
          <div class="culture-item">
            <h3 class="subsection-title">{{ $t('about.culture.mission.title') }}</h3>
            <p class="mission-text">{{ $t('about.culture.mission.content') }}</p>
          </div>
          <div class="culture-divider"></div>
          <!-- 愿景部分 -->
          <div class="culture-item">
            <h3 class="subsection-title">{{ $t('about.culture.vision.title') }}</h3>
            <p class="vision-text">{{ $t('about.culture.vision.content') }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 内容区域继续 -->
    <div class="content-container">
      <!-- 发展历程部分 -->
      <section id="history" class="content-section">
        <div class="section-content">
          <h2>{{ $t('about.history.title') }}</h2>
          <div class="timeline">
            <div class="timeline-line"></div>
            <div
              v-for="(item, index) in historyData"
              :key="index"
              class="timeline-item"
              :class="{ visible: timelineItemsVisible[index] }"
            >
              <div class="timeline-axis">
                <div class="timeline-dot"></div>
                <div class="axis-dash"></div>
                <div class="timeline-year">{{ item.year }}</div>
              </div>
              <div class="timeline-info">
                <div class="timeline-title">{{ item.title }}</div>
                <ul>
                  <li
                    v-for="(event, eIndex) in item.events"
                    :key="eIndex"
                    :class="{ visible: timelineListItemsVisible[`${index}-${eIndex}`] }"
                  >{{ event }}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>

    <!-- 荣誉资质部分 -->
    <section id="honors" class="honors-section-full">
      <div class="honors-bg">
        <div class="honors-content-custom">
          <h2 class="honors-title">{{ $t('about.honors.title') }}</h2>
          <div class="honors-desc">{{ $t('about.honors.desc') }}</div>
          <div class="honor-coverflow-wrapper">
            <div class="honor-coverflow-list">
              <div
                v-for="(image, index) in honorImages"
                :key="index"
                class="honor-coverflow-item"
                :class="getItemClass(index)"
                @click="handleImageClick(index)"
              >
                <img :src="image" />
              </div>
            </div>
            <button class="arrow left" @click="prevHonor" :disabled="isSliding">❮</button>
            <button class="arrow right" @click="nextHonor" :disabled="isSliding">❯</button>
          </div>
          <div class="honor-caption">{{ $t(`about.honors.items.${currentHonorIndex + 1}.title`) }}</div>

          <!-- 添加图片预览遮罩层 -->
          <div class="image-preview-overlay" v-if="showPreview">
            <div class="close-button" @click="closePreview">X</div>
            <div class="preview-content">
              <img
                :src="honorImages[currentHonorIndex]"
                :style="{ 
                  transform: `scale(${zoomScale}) translate(${dragOffset.x}px, ${dragOffset.y}px)`,
                  cursor: isDragging ? 'grabbing' : 'grab'
                }"
                @wheel.prevent="handleWheel"
                @mousedown="startDrag"
                @mousemove="onDrag"
                @mouseup="stopDrag"
                @mouseleave="stopDrag"
              />
              <div class="zoom-info">{{ Math.round(zoomScale * 100) }}%</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 内容区域继续 -->
    <div class="content-container">
      <!-- 合作伙伴部分 -->
      <section id="partners" class="partners-section-full">
        <div class="partners-content">
          <h2 class="section-title">{{ $t('about.partners.title') }}</h2>
          <div class="partners-grid">
            <div v-for="i in 12" :key="i" class="partner-item">
              <img
                :src="require(`@/assets/logo/${i}.png`)"
                :alt="`Partner ${i}`"
                class="partner-logo"
                @error="handleImageError"
              />
            </div>
          </div>
        </div>
      </section>
    </div>

    <!-- 使用 CommonSection 组件显示页脚 -->
    <common-section type="footer" id="contact" @scroll-to-section="scrollToSection" />
  </div>
</template>

<script>
import CommonHeader from "@/components/CommonHeader.vue";
import CommonSection from "@/components/CommonSection.vue";

export default {
  name: "AboutView",
  components: {
    CommonHeader,
    CommonSection
  },
  data() {
    return {
      currentSection: "about",
      currentLang: "CN",
      sectionLock: false,
      scrollUnlockTimer: null,
      scrollRAF: null,
      scrollTarget: null,
      isScrolled: false,
      honors: [
        {
          title: "国家高新技术企业",
          description: "由科技部、财政部、国家税务总局联合认定的高新技术企业",
          date: "2017年",
          image:
            "https://via.placeholder.com/400x300/409EFF/FFFFFF?text=国家高新技术企业"
        },
        {
          title: "高工锂电投资价值企业奖",
          description: "在新能源领域的技术创新和市场表现获得行业认可",
          date: "2022年",
          image:
            "https://via.placeholder.com/400x300/409EFF/FFFFFF?text=高工锂电投资价值企业奖"
        },
        {
          title: "LG新能源A级设备供应商",
          description: "凭借优质的产品和服务获得LG新能源的高度认可",
          date: "2021年",
          image:
            "https://via.placeholder.com/400x300/409EFF/FFFFFF?text=LG新能源A级设备供应商"
        },
        {
          title: "比亚迪年度最佳供应商",
          description: "在产品质量、技术创新和服务等方面表现突出",
          date: "2022年",
          image:
            "https://via.placeholder.com/400x300/409EFF/FFFFFF?text=比亚迪年度最佳供应商"
        }
      ],
      certificates: [
        {
          title: "ISO9001质量管理体系认证",
          description: "质量管理体系符合国际标准要求",
          number: "ISO9001:2015",
          image:
            "https://via.placeholder.com/400x300/409EFF/FFFFFF?text=ISO9001认证"
        },
        {
          title: "ISO14001环境管理体系认证",
          description: "环境管理体系符合国际标准要求",
          number: "ISO14001:2015",
          image:
            "https://via.placeholder.com/400x300/409EFF/FFFFFF?text=ISO14001认证"
        },
        {
          title: "知识产权管理体系认证",
          description: "知识产权管理体系符合国家标准要求",
          number: "GB/T29490-2013",
          image:
            "https://via.placeholder.com/400x300/409EFF/FFFFFF?text=知识产权管理体系认证"
        },
        {
          title: "安全生产标准化认证",
          description: "安全生产管理体系符合国家标准要求",
          number: "AQ/T9006-2010",
          image:
            "https://via.placeholder.com/400x300/409EFF/FFFFFF?text=安全生产标准化认证"
        }
      ],
      strategicPartners: [
        {
          name: "LG新能源",
          description: "全球领先的动力电池制造商",
          logo:
            "https://via.placeholder.com/200x100/409EFF/FFFFFF?text=LG新能源"
        },
        {
          name: "比亚迪",
          description: "中国新能源汽车领军企业",
          logo: "https://via.placeholder.com/200x100/409EFF/FFFFFF?text=比亚迪"
        },
        {
          name: "宁德时代",
          description: "全球动力电池龙头企业",
          logo:
            "https://via.placeholder.com/200x100/409EFF/FFFFFF?text=宁德时代"
        }
      ],
      partners: [
        {
          name: "西门子",
          description: "工业自动化解决方案提供商",
          logo: "https://via.placeholder.com/200x100/409EFF/FFFFFF?text=西门子"
        },
        {
          name: "ABB",
          description: "电气设备制造商",
          logo: "https://via.placeholder.com/200x100/409EFF/FFFFFF?text=ABB"
        },
        {
          name: "发那科",
          description: "工业机器人制造商",
          logo: "https://via.placeholder.com/200x100/409EFF/FFFFFF?text=发那科"
        },
        {
          name: "库卡",
          description: "工业机器人制造商",
          logo: "https://via.placeholder.com/200x100/409EFF/FFFFFF?text=库卡"
        },
        {
          name: "安川电机",
          description: "工业自动化设备制造商",
          logo:
            "https://via.placeholder.com/200x100/409EFF/FFFFFF?text=安川电机"
        },
        {
          name: "三菱电机",
          description: "工业自动化设备制造商",
          logo:
            "https://via.placeholder.com/200x100/409EFF/FFFFFF?text=三菱电机"
        }
      ],
      coreStatsAnimated: false,
      coreStats: [
        { value: 2013, display: 0, unit: "年", label: "公司成立" },
        { value: 200, display: 0, unit: "+", label: "投运项目" },
        { value: 20000, display: 0, unit: "万", label: "年产值" },
        { value: 200, display: 0, unit: "+", label: "合作企业" }
      ],
      timelineItemsVisible: [],
      timelineListItemsVisible: {},
      currentHonorIndex: 0,
      honorImages: [
        require("@/assets/honors/1.jpg"),
        require("@/assets/honors/2.jpg"),
        require("@/assets/honors/3.jpg"),
        require("@/assets/honors/4.jpg"),
        require("@/assets/honors/5.jpg"),
        require("@/assets/honors/6.jpg"),
        require("@/assets/honors/7.jpg"),
        require("@/assets/honors/8.jpg"),
        require("@/assets/honors/9.jpg"),
        require("@/assets/honors/10.jpg")
      ],
      isSliding: false,
      showPreview: false,
      zoomScale: 1,
      minZoom: 0.5,
      maxZoom: 3,
      isDragging: false,
      dragStart: { x: 0, y: 0 },
      dragOffset: { x: 0, y: 0 },
      lastDragOffset: { x: 0, y: 0 }
    };
  },
  computed: {
    historyData() {
      return this.$t("about.historyData");
    }
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("scroll", this.handleCoreStatsScroll);
    this.checkHash();
    this.$nextTick(() => {
      this.initTimelineObserver();
    });
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("scroll", this.handleCoreStatsScroll);
    if (this.scrollRAF) {
      cancelAnimationFrame(this.scrollRAF);
    }
    if (this.timelineObserver) {
      this.timelineObserver.disconnect();
    }
  },
  methods: {
    handleSearch(searchText) {
      if (searchText.trim()) {
        console.log("Searching for:", searchText);
      }
    },
    switchLang(lang) {
      this.currentLang = lang;
    },
    handleSectionChange(section) {
      this.currentSection = section;
    },
    handleScroll() {
      if (this.scrollRAF) {
        cancelAnimationFrame(this.scrollRAF);
      }
      this.scrollRAF = requestAnimationFrame(() => {
        const bannerEl = document.querySelector(".page-banner");
        if (bannerEl) {
          const bannerBottom = bannerEl.getBoundingClientRect().bottom;
          this.isScrolled = window.scrollY > bannerBottom;
        }
        if (this.sectionLock || this.scrollTarget) {
          return;
        }
        const sections = [
          "profile",
          "culture",
          "history",
          "honors",
          "partners"
        ];
        const offset = 192;
        let currentSection = this.currentSection;
        let minDistance = Infinity;
        const sectionRects = sections
          .map(section => {
            const element = document.getElementById(section);
            return element
              ? {
                  section,
                  rect: element.getBoundingClientRect()
                }
              : null;
          })
          .filter(Boolean);
        sectionRects.forEach(({ section, rect }) => {
          if (rect.top <= offset && rect.bottom >= offset) {
            const distance = Math.abs(rect.top - offset);
            if (distance < minDistance) {
              minDistance = distance;
              currentSection = section;
            }
          }
        });

        if (currentSection !== this.currentSection) {
          this.currentSection = currentSection;
          if (window.location.hash !== `#${currentSection}`) {
            history.replaceState(null, null, `#${currentSection}`);
          }
        }
      });
    },
    checkHash() {
      const hash = window.location.hash.slice(1);
      if (
        hash &&
        ["profile", "culture", "history", "honors", "partners"].includes(hash)
      ) {
        this.currentSection = hash;
        this.$nextTick(() => {
          const element = document.getElementById(hash);
          if (element) {
            element.scrollIntoView({ behavior: "smooth" });
          }
        });
      }
    },
    scrollToSection(section) {
      const element = document.getElementById(section);
      if (element) {
        const offset = 192;
        const top =
          element.getBoundingClientRect().top + window.pageYOffset - offset;

        this.scrollTarget = section;
        this.sectionLock = true;
        requestAnimationFrame(() => {
          window.scrollTo({ top, behavior: "smooth" });

          if (window.location.hash !== `#${section}`) {
            history.replaceState(null, null, `#${section}`);
          }
          const checkScrollEnd = () => {
            const currentTop = window.pageYOffset;
            if (Math.abs(currentTop - top) < 5) {
              this.currentSection = section;
              this.scrollTarget = null;
              this.sectionLock = false;
            } else {
              requestAnimationFrame(checkScrollEnd);
            }
          };

          setTimeout(checkScrollEnd, 300);
        });
      }
    },
    handleCoreStatsScroll() {
      const el = document.querySelector(".core-stats-bg");
      if (!el) return;
      const rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom > 0) {
        if (!this.coreStatsAnimated) {
          this.animateCoreStats();
          this.coreStatsAnimated = true;
        }
      } else {
        this.coreStatsAnimated = false;
      }
    },
    animateCoreStats() {
      this.coreStats.forEach(stat => {
        stat.display = 0;
        const target = stat.value;
        const steps = 30;
        const duration = 800;
        const step = target / steps;
        let current = 0;
        let count = 0;
        const timer = setInterval(() => {
          current += step;
          count++;
          if (count >= steps) {
            stat.display = target;
            clearInterval(timer);
          } else {
            stat.display = Math.round(current);
          }
        }, duration / steps);
      });
    },
    initTimelineObserver() {
      this.timelineObserver = new IntersectionObserver(
        entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              const index = entry.target.dataset.index;
              this.$set(this.timelineItemsVisible, index, true);

              const listItems = entry.target.querySelectorAll(
                ".timeline-info ul li"
              );
              listItems.forEach((item, itemIndex) => {
                setTimeout(() => {
                  this.$set(
                    this.timelineListItemsVisible,
                    `${index}-${itemIndex}`,
                    true
                  );
                }, itemIndex * 200);
              });

              this.timelineObserver.unobserve(entry.target);
            }
          });
        },
        {
          threshold: 0.8,
          rootMargin: "0px"
        }
      );

      this.$nextTick(() => {
        const items = document.querySelectorAll(".timeline-item");
        items.forEach((item, index) => {
          item.dataset.index = index;
          this.timelineItemsVisible[index] = false;
          const listItems = item.querySelectorAll(".timeline-info ul li");
          listItems.forEach((_, itemIndex) => {
            this.$set(
              this.timelineListItemsVisible,
              `${index}-${itemIndex}`,
              false
            );
          });
          this.timelineObserver.observe(item);
        });
      });
    },
    getPositionClass(offset) {
      const positions = [
        "pos-3",
        "pos-2",
        "pos-1",
        "pos0",
        "pos1",
        "pos2",
        "pos3"
      ];
      const index = (offset + 3 + 7) % 7;
      return positions[index];
    },
    getItemClass(index) {
      const len = this.honorImages.length;
      const centerIndex = this.currentHonorIndex;

      let relativeIndex = (index - centerIndex + len) % len;
      if (relativeIndex > len / 2) {
        relativeIndex -= len;
      }

      if (relativeIndex === 0) return "center";
      if (relativeIndex === -1) return "left";
      if (relativeIndex === 1) return "right";
      if (relativeIndex === -2) return "far-left";
      if (relativeIndex === 2) return "far-right";
      return "";
    },
    prevHonor() {
      if (this.isSliding) return;
      this.isSliding = true;
      this.currentHonorIndex =
        (this.currentHonorIndex - 1 + this.honorImages.length) %
        this.honorImages.length;
      setTimeout(() => {
        this.isSliding = false;
      }, 400);
    },
    nextHonor() {
      if (this.isSliding) return;
      this.isSliding = true;
      this.currentHonorIndex =
        (this.currentHonorIndex + 1) % this.honorImages.length;
      setTimeout(() => {
        this.isSliding = false;
      }, 400);
    },
    startDrag(e) {
      if (e.button !== 0) return; // 只处理左键点击
      this.isDragging = true;
      this.dragStart = {
        x: e.clientX,
        y: e.clientY
      };
      this.lastDragOffset = { ...this.dragOffset };
      e.preventDefault();
    },
    onDrag(e) {
      if (!this.isDragging) return;

      const deltaX = e.clientX - this.dragStart.x;
      const deltaY = e.clientY - this.dragStart.y;

      // 计算新的偏移量
      const newX = this.lastDragOffset.x + deltaX;
      const newY = this.lastDragOffset.y + deltaY;

      // 根据缩放比例计算最大可拖动范围
      const maxOffset = Math.max(0, (this.zoomScale - 1) * 200);

      // 限制拖动范围
      this.dragOffset = {
        x: Math.max(Math.min(newX, maxOffset), -maxOffset),
        y: Math.max(Math.min(newY, maxOffset), -maxOffset)
      };
    },
    stopDrag() {
      if (!this.isDragging) return;
      this.isDragging = false;
    },
    handleWheel(e) {
      const delta = e.deltaY > 0 ? -0.1 : 0.1;
      const oldScale = this.zoomScale;
      const newScale = Math.min(
        Math.max(this.zoomScale + delta, this.minZoom),
        this.maxZoom
      );

      // 获取图片元素
      const img = e.target;
      const rect = img.getBoundingClientRect();

      // 计算鼠标在图片上的相对位置
      const mouseX = e.clientX - rect.left;
      const mouseY = e.clientY - rect.top;

      // 计算缩放前后的相对位置
      const scaleRatio = newScale / oldScale;

      // 更新缩放比例
      this.zoomScale = newScale;

      // 调整拖动偏移以保持鼠标位置不变
      if (newScale !== oldScale) {
        const newOffsetX = mouseX - (mouseX - this.dragOffset.x) * scaleRatio;
        const newOffsetY = mouseY - (mouseY - this.dragOffset.y) * scaleRatio;

        // 限制新的偏移量
        const maxOffset = Math.max(0, (newScale - 1) * 200);
        this.dragOffset = {
          x: Math.max(Math.min(newOffsetX, maxOffset), -maxOffset),
          y: Math.max(Math.min(newOffsetY, maxOffset), -maxOffset)
        };
      }
    },
    handleImageClick(index) {
      if (this.getItemClass(index) === "center") {
        this.showPreview = true;
        this.zoomScale = 1;
        this.dragOffset = { x: 0, y: 0 };
        this.lastDragOffset = { x: 0, y: 0 };
      }
    },
    closePreview() {
      this.showPreview = false;
      this.zoomScale = 1;
      this.dragOffset = { x: 0, y: 0 };
      this.lastDragOffset = { x: 0, y: 0 };
    },
    handleImageError(e) {
      console.error("Failed to load partner image:", e.target.src);
      e.target.style.display = "none";
    }
  }
};
</script>

<style lang="scss" scoped>
.about {
  .content-container {
    width: 100%;
    max-width: 1400px;
    padding: 60px 20px;
    margin: 0 auto;
    position: relative;
    z-index: 1;
    scroll-behavior: smooth;
  }
  .section-content {
    width: 100%;
    max-width: 100vw;
    padding: 0 20px;
    box-sizing: border-box;
  }

  .page-banner {
    height: 65vh;
    // background: linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('@/assets/banners/about-banner.jpg');
    background: url("@/assets/banners/about-banner.jpg");
    background-size: 100% auto;
    background-position: center;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    text-align: center;
    .banner-content {
      h1 {
        font-size: 48px;
        margin-bottom: 15px;
        font-weight: 600;
      }

      p {
        font-size: 24px;
        opacity: 0.9;
      }
    }
  }

  .content-container {
    max-width: 1400px;
    margin: 0 auto;
    padding: 60px 0px;

    .content-section {
      scroll-margin-top: 100px;
      &:last-child {
        margin-bottom: 0;
      }

      .section-content {
        h2 {
          font-size: 35px;
          font-weight: 700;
          color: #333;
          margin-bottom: 30px;
          text-align: center;
          position: relative;
          padding-bottom: 15px;
        }
      }
    }
  }

  .profile-content {
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin-bottom: 40px;
    .profile-left {
      flex: 0 0 35%;
      max-width: 45%;
      .profile-text {
        p {
          font-size: 17px;
          line-height: 1.8;
          color: #666;
          margin-bottom: 20px;
          text-align: justify;
        }
      }
    }

    .profile-right {
      flex: 0 0 45%;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        width: 100%;
        max-width: 100%;
        max-height: 320px;
        border-radius: 12px;
        box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
        object-fit: cover;
        display: block;
      }
    }
  }

  @media (max-width: 900px) {
    .profile-content {
      flex-direction: column;
      .profile-left,
      .profile-right {
        max-width: 100%;
        flex: 1 1 100%;
      }
      .profile-right {
        margin-top: 24px;
        img {
          max-width: 100%;
          max-height: 220px;
        }
      }
    }
  }

  .culture-section-full {
    background: url("@/assets/guan/qiye.png") no-repeat center center;
    background-size: cover;
    position: relative;
    min-height: 550px;

    .culture-content {
      width: 100%;
      height: 500px;
      position: relative;
      z-index: 2;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .wenhuabiaoti {
      color: #fff;
      font-size: 35px;
      font-weight: 700;
      text-align: center;
      margin: 50px 0 40px 0;
      width: 100%;

      @media (max-width: 967px) {
        font-size: 28px;
        margin: 30px 0 20px 0;
      }
    }

    .culture-grid {
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: stretch;
      width: 100%;
      padding: 0 40px;
      box-sizing: border-box;

      @media (max-width: 1200px) {
        padding: 0 20px;
      }

      @media (max-width: 967px) {
        flex-direction: column;
        height: auto;
        padding: 0 15px;
        gap: 30px;
      }
    }

    .culture-item {
      flex: 1;
      text-align: center;
      padding: 0 20px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding-bottom: 3%;

      @media (max-width: 1200px) {
        padding: 0 15px;
      }

      @media (max-width: 768px) {
        padding: 0;
        padding-bottom: 20px;
      }

      p {
        text-align: center;
      }
    }

    .culture-divider {
      width: 1px;
      background: rgba(255, 255, 255, 0.3);

      @media (max-width: 768px) {
        width: 100%;
        height: 1px;
        margin: 0;
      }
    }

    .subsection-title {
      font-size: 24px;
      color: #fff;
      margin-bottom: 40px;
      font-weight: 600;

      @media (max-width: 1200px) {
        font-size: 22px;
        margin-bottom: 30px;
      }

      @media (max-width: 768px) {
        font-size: 20px;
        margin-bottom: 20px;
      }
    }

    .value-list {
      list-style: none;
      padding: 0;
      margin: 0;
      display: flex;
      justify-content: center;
      gap: 20px;

      // 中文布局
      &.value-list-zh {
        flex-wrap: nowrap;
        li {
          flex: 1;
          white-space: nowrap;
        }

        // 当容器宽度不够时，自动变成一行3个
        @media (max-width: 1200px) {
          flex-wrap: wrap;
          li {
            flex: 0 0 calc(33.333% - 20px);
            white-space: normal;
          }
        }
      }

      // 英文布局（默认一行3个）
      &:not(.value-list-zh) {
        flex-wrap: wrap;
        li {
          flex: 0 0 calc(33.333% - 20px);
        }
      }

      li {
        font-size: 18px;
        color: #fff;
        text-align: center;
        margin-bottom: 15px;
        position: relative;
        &:last-child {
          margin-bottom: 0;
        }
      }

      @media (max-width: 768px) {
        flex-direction: column;
        align-items: center;
        gap: 10px;

        li {
          width: 100%;
          max-width: 300px;
          margin-bottom: 0;
        }
      }
    }

    .mission-text,
    .vision-text {
      font-size: 18px;
      color: #fff;
      line-height: 1.8;
      text-align: left;

      @media (max-width: 1200px) {
        font-size: 16px;
        line-height: 1.6;
      }

      @media (max-width: 768px) {
        font-size: 15px;
        text-align: center;
      }
    }

    @media (max-width: 768px) {
      min-height: auto;
      padding: 30px 0;

      .culture-content {
        height: auto;
        padding: 0 15px;
      }
    }
  }

  .timeline {
    position: relative;
    max-width: 900px;
    margin: 0 auto;
  }
  .timeline-line {
    position: absolute;
    left: 8px;
    top: 9px;
    width: 4px;
    height: 94%;
    background: linear-gradient(
      to bottom,
      #edeef1 0%,
      #1d2088 50%,
      #1d2088 70%,
      #edeef1 100%
    );
    border-radius: 2px;
    z-index: 0;
    pointer-events: none;
  }

  .timeline-item {
    display: flex;
    align-items: flex-start;
    position: relative;
    min-height: 56px;
    margin-bottom: 38px;
    z-index: 1;
    opacity: 0;
    transform: translateY(50px);
    transition: all 1s cubic-bezier(0.4, 0, 0.2, 1);

    &.visible {
      opacity: 1;
      transform: translateY(0);
    }
  }
  .timeline-axis {
    position: relative;
    width: 240px;
    display: flex;
    align-items: center;
    z-index: 2;
  }
  .timeline-dot {
    width: 20px;
    height: 20px;
    background: #1d2088;
    border-radius: 50%;
    box-shadow: 0 2px 8px rgba(29, 32, 136, 0.1);
    z-index: 2;
    margin-right: 0;
    margin-left: 0;
    position: relative;
    left: 0;
    top: 0;
    transform: none;
  }
  .axis-dash {
    flex: 1 1 auto;
    height: 0;
    border-bottom: 1px dashed #a1a3cb;
    margin: 0 4px;
    min-width: 24px;
  }
  .timeline-year {
    font-size: 44px;
    color: #2c2f90;
    font-weight: 700;
    margin-right: 8px;
    letter-spacing: 1px;
    line-height: 1;
    z-index: 2;
    margin-left: 0;
  }
  .timeline-info {
    flex: 1 1 0;
    padding-left: 25px;
    margin-left: 10px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    border-left: 1px solid #bfbfbf;
  }
  .timeline-title {
    font-size: 28px;
    color: #222;
    font-weight: 700;
    margin-bottom: 8px;
    margin-top: 0;
  }
  .timeline-info ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  .timeline-info ul li {
    font-size: 16px;
    color: #555;
    margin-bottom: 6px;
    padding-left: 22px;
    position: relative;
  }
  .timeline-info ul li::before {
    content: "";
    display: inline-block;
    width: 13px;
    height: 13px;
    border-radius: 50%;
    background: #666666;
    position: absolute;
    left: 0;
    top: 6px;
  }
  @media (max-width: 900px) {
    .timeline {
      padding: 30px 0 20px 0;
    }
    .timeline-line {
      left: 14px;
      width: 3px;
    }
    .line-dash,
    .line-solid {
      width: 3px;
    }
    .line-dash.top,
    .line-dash.bottom {
      height: 28px;
    }
    .line-solid {
      height: calc(100% - 56px);
      min-height: 30px;
    }
    .timeline-item {
      flex-direction: column;
      align-items: flex-start;
      margin-bottom: 28px;
    }
    .timeline-axis {
      width: 120px;
      margin-left: 9px;
    }
    .axis-dash {
      min-width: 10px;
      margin: 0 6px;
      border-bottom-width: 1.5px;
    }
    .timeline-dot {
      width: 14px;
      height: 14px;
    }
    .timeline-year {
      font-size: 20px;
    }
    .timeline-title {
      font-size: 16px;
      margin-bottom: 6px;
    }
    .timeline-info {
      margin-left: 42px;
    }
    .timeline-info ul li {
      font-size: 14px;
      margin-bottom: 4px;
      padding-left: 16px;
    }
    .timeline-info ul li::before {
      width: 6px;
      height: 6px;
      top: 7px;
    }
  }

  .honors-section-full {
    width: 100vw;
    position: relative;
    left: 50%;
    right: 50%;
    margin-left: -50vw;
    margin-right: -50vw;
    overflow: hidden;
    margin-bottom: 20px;
  }

  .honors-bg {
    width: 100vw;
    min-height: 700px;
    background: url("@/assets/honor-bg.jpg") center center/cover no-repeat;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .honors-content-custom {
    width: 100%;
    max-width: 1600px;
    margin: 0 auto;
    text-align: center;
    color: #fff;
    padding: 60px 20px;
    position: relative;
    z-index: 2;
  }
  .honors-title {
    font-size: 48px;
    font-weight: 700;
    margin-bottom: 24px;
    letter-spacing: 2px;
    text-shadow: 0 4px 24px rgba(0, 0, 0, 0.25);
  }
  .honors-desc {
    font-size: 22px;
    font-weight: 400;
    margin-bottom: 40px;
    line-height: 1.7;
    text-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);
  }
  .honor-coverflow-wrapper {
    position: relative;
    width: 100%;
    height: 340px;
    overflow: hidden;
  }
  .honor-coverflow-list {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: transform 0.4s ease-in-out;
  }
  .honor-coverflow-item {
    position: absolute;
    width: 320px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all 0.4s ease-in-out;
    opacity: 0.5;
    transform: scale(0.8);
    cursor: pointer;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
      border-radius: 8px;
      box-shadow: 0 4px 24px rgba(0, 0, 0, 0.18);
      transition: all 0.4s ease-in-out;
    }

    &.center {
      opacity: 1 !important;
      transform: scale(1.1);
      z-index: 3;

      img {
        border-color: #fffbe6;
        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.25);
      }
    }

    &.left {
      transform: translateX(-320px) scale(0.9);
      opacity: 0.7;
      z-index: 2;
    }

    &.right {
      transform: translateX(320px) scale(0.9);
      opacity: 0.7;
      z-index: 2;
    }

    &.far-left {
      transform: translateX(-640px) scale(0.8);
      opacity: 0.5;
      z-index: 1;
    }

    &.far-right {
      transform: translateX(640px) scale(0.8);
      opacity: 0.5;
      z-index: 1;
    }
  }
  .arrow {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 40px;
    height: 40px;
    background: rgba(0, 0, 0, 0.3);
    border: none;
    border-radius: 50%;
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    z-index: 3;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s;

    &:hover {
      background: rgba(0, 0, 0, 0.5);
    }

    &.left {
      left: 20px;
    }

    &.right {
      right: 20px;
    }
  }
  .honor-caption {
    text-align: center;
    font-size: 20px;
    color: #fff;
    margin-top: 20px;
    font-weight: 500;
    text-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
  @media (max-width: 1000px) {
    .honor-coverflow-wrapper {
      height: 280px;
    }

    .honor-coverflow-item {
      width: 280px;

      &.center {
        transform: scale(1);
        opacity: 1 !important;
      }

      &.left {
        transform: translateX(-280px) scale(0.9);
      }

      &.right {
        transform: translateX(280px) scale(0.9);
      }

      &.far-left {
        transform: translateX(-560px) scale(0.8);
      }

      &.far-right {
        transform: translateX(560px) scale(0.8);
      }
    }

    .arrow {
      width: 36px;
      height: 36px;
      font-size: 18px;

      &.left {
        left: 10px;
      }

      &.right {
        right: 10px;
      }
    }
  }

  .partners-section-full {
    padding: 60px 0;
    background: #fff;

    .partners-content {
      max-width: 1300px;
      margin: 0 auto;
      padding: 0 20px;

      .section-title {
        text-align: center;
        font-size: 32px;
        color: #1d2088;
        margin-bottom: 40px;
        font-weight: 600;
      }

      .partners-grid {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 20px;
        justify-items: center;
        align-items: center;

        .partner-item {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 10px;

          .partner-logo {
            width: 96%;
            height: auto;
            object-fit: contain;
          }

          &:nth-last-child(2) .partner-logo {
            max-width: 222px;
            max-height: 103px;
          }

          &:last-child .partner-logo {
            max-width: 180px;
            max-height: 65px;
          }
        }
      }
    }
  }

  @media (max-width: 1024px) {
    .partners-section-full {
      .partners-content {
        .partners-grid {
          .partner-item {
            .partner-logo {
              max-width: 180px;
              max-height: 90px;
            }
          }
        }
      }
    }
  }

  @media (max-width: 768px) {
    .partners-section-full {
      padding: 40px 0;

      .partners-content {
        .section-title {
          font-size: 28px;
          margin-bottom: 30px;
        }

        .partners-grid {
          grid-template-columns: repeat(2, 1fr);
          gap: 10px;

          .partner-item {
            padding: 5px;
            .partner-logo {
              max-width: 140px;
              max-height: 70px;
            }
          }
        }
      }
    }
  }

  .core-stats-bg {
    width: 99vw;
    height: 450px;
    position: relative;
    left: 50%;
    right: 50%;
    margin-left: -50vw;
    margin-right: -50vw;
    background: url("@/assets/guan/nfbg.jpg") center center/cover no-repeat;
    padding: 48px 0 36px 0;
    display: flex;
    justify-content: center;
    align-items: center;

    @media (max-width: 1200px) {
      height: auto;
      min-height: 400px;
      padding: 40px 0;
    }

    @media (max-width: 768px) {
      min-height: 350px;
      padding: 30px 0;
    }

    .core-stats-inner {
      width: 90%;
      max-width: 1400px;
      margin: 0 auto;
      text-align: center;

      @media (max-width: 768px) {
        width: 95%;
      }

      .core-slogan {
        font-size: 32px;
        color: #1b1b1b;
        font-weight: 700;
        margin-bottom: 93px;
        letter-spacing: 2px;
        text-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);

        @media (max-width: 1200px) {
          font-size: 28px;
          margin-bottom: 60px;
        }

        @media (max-width: 768px) {
          font-size: 24px;
          margin-bottom: 40px;
        }
      }

      .core-stats-list {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        gap: 185px;
        flex-wrap: wrap;

        @media (max-width: 1450px) {
          gap: 60px;
          justify-content: center;
        }

        @media (max-width: 768px) {
          gap: 30px;
        }

        .core-stat-item {
          flex: 1 1 0;
          background: transparent;
          border-radius: 0;
          padding: 0;
          margin: 0 8px;
          box-shadow: none;
          display: flex;
          flex-direction: column;
          align-items: center;
          min-width: 160px;

          @media (max-width: 1200px) {
            flex: 0 0 calc(50% - 30px);
            margin: 0;
          }

          @media (max-width: 768px) {
            margin: 0;
          }

          .core-stat-number {
            font-size: 50px;
            color: #1d2088;
            font-weight: 700;
            margin-bottom: 10px;
            text-shadow: none;
            line-height: 1;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 4px;

            @media (max-width: 1200px) {
              font-size: 42px;
            }

            @media (max-width: 768px) {
              font-size: 36px;
            }

            .core-unit {
              font-size: 16px;
              color: #1d2088;
              margin-left: 2px;
              font-weight: 700;

              @media (max-width: 768px) {
                font-size: 14px;
              }
            }
          }

          .core-stat-label {
            font-size: 16px;
            color: #111;
            opacity: 1;
            letter-spacing: 1px;
            margin-top: 2px;

            @media (max-width: 768px) {
              font-size: 14px;
            }
          }
        }
      }
    }
  }

  .image-preview-overlay {
    position: fixed;
    top: 20%;
    left: 0;
    height: 80%;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.9);
    z-index: 1000;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;

    .close-button {
      position: fixed;
      top: 21%;
      right: 19%;
      width: 40px;
      height: 40px;
      background: rgba(255, 255, 255, 0.2);
      border: 2px solid rgba(255, 255, 255, 0.5);
      border-radius: 50%;
      color: white;
      font-size: 32px;
      font-weight: bold;
      line-height: 36px;
      text-align: center;
      cursor: pointer;
      z-index: 1001;
      box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
      &:hover {
        background: rgba(255, 0, 0, 0.8);
        border-color: white;
        box-shadow: 0 2px 15px rgba(255, 0, 0, 0.4);
      }
    }

    .preview-content {
      height: 98%;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      user-select: none;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
        border-radius: 4px;
        box-shadow: 0 4px 24px rgba(0, 0, 0, 0.3);
        transition: transform 0.05s ease-out;
        object-fit: contain;
        will-change: transform;
        touch-action: none; // 防止触摸设备上的默认行为
      }

      .zoom-info {
        position: absolute;
        bottom: 20px;
        right: 20px;
        background: rgba(0, 0, 0, 0.7);
        color: white;
        padding: 8px 12px;
        border-radius: 4px;
        font-size: 14px;
        pointer-events: none;
      }
    }
  }
}

@media (max-width: 1200px) {
  .about {
    .content-container {
      .profile-content {
        .core-data {
          grid-template-columns: repeat(2, 1fr);
        }
      }

      .culture-content {
        grid-template-columns: repeat(2, 1fr);
      }
    }
  }
}

@media (max-width: 992px) {
  .about {
    .content-container {
      .timeline {
        &::before {
          left: 30px;
        }

        .timeline-item {
          justify-content: flex-start;

          .year {
            left: 30px;
            transform: none;
          }

          .content {
            width: calc(100% - 60px);
            margin-left: 60px !important;
            margin-right: 0 !important;

            &::before {
              left: -10px !important;
              right: auto !important;
            }
          }
        }
      }
    }
  }
}

@media (max-width: 768px) {
  .about {
    .page-banner {
      height: 300px;
      .banner-content {
        h1 {
          font-size: 36px;
        }

        p {
          font-size: 18px;
        }
      }
    }

    .content-container {
      padding: 40px 20px;

      .content-section {
        margin-bottom: 60px;

        .section-content {
          h2 {
            font-size: 28px;
          }
        }
      }

      .profile-content {
        .core-data {
          grid-template-columns: 1fr;
        }
      }

      .culture-content {
        grid-template-columns: 1fr;
      }

      .partners-content {
        .partners-image {
          width: 100%;
          height: auto;
          display: block;
          border-radius: 8px;
          box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
        }
      }
    }
  }
}

.about-subnav {
  width: 100%;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
  position: sticky;
  top: 100px;
  z-index: 100;
  display: flex;
  justify-content: center;
  height: 93px;
  transition: all 0.3s ease;

  @media (max-width: 1200px) {
    display: none;
  }

  &.subnav-scrolled {
    background: #fff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
  }

  .subnav-inner {
    width: 80%;
    max-width: 1400px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0;
    margin: 0 auto;
  }

  ul {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0;
    margin: 0;
    list-style: none;
  }

  li {
    flex: 1 1 0;
    text-align: center;
    position: relative;
    height: 54px;

    a {
      display: block;
      font-size: 18px;
      color: #333;
      padding: 10px 0;
      transition: all 0.3s ease;
      text-decoration: none;
      position: relative;

      &::after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 50%;
        width: 0;
        height: 3px;
        background: linear-gradient(90deg, #a2ca07, #009fd9);
        transition: all 0.3s ease;
        transform: translateX(-50%);
        border-radius: 2px;
        opacity: 0;
      }
    }

    &.active a {
      color: #1d2088;
      font-weight: 600;

      &::after {
        width: 60%;
        opacity: 1;
      }
    }

    a:hover {
      color: #1d2088;
      font-weight: 600;

      &::after {
        width: 60%;
        opacity: 1;
      }
    }
  }
}
</style>
<style lang="scss">
::-webkit-scrollbar {
  width: 6px;
  height: 0px;
}
::-webkit-scrollbar-thumb {
  background: #1d2088;
  border-radius: 3px;
}
::-webkit-scrollbar-track {
  background: transparent;
}
</style>